/*
 *   File : send-mail.js
 *   Author : https://zappit.com
 *   Description : Send mail  modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages

// custom components
import { PrimaryButton } from '../Buttons';

// custom styles
import style from "../../Style/Components/modal.module.scss";


const VerifyDetail = (props) => {


    return (
        <div className="modal fade "
            id="verify-details-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SendMailModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered ${style.e_send_mail_modal_width}  border-radius-28`}>
                <span id='open-account-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content  border-radius-28  border-0`}>

                    <div className='modal-body pt-4 pb-0 padding-32px-lr text-center'>
                        <img src={props.rcFetched || props.passport ? require("../../Assets/Images/failed.gif") : require("../../Assets/Images/check-circle.gif")}
                            alt="Success"
                            width={props.rcFetched || props.passport ? 160 : 80} />
                        {
                            !props.rcFetched && !props.passport ?
                                <h6 className='mb-0 color-white e-primary-font py-2 e-font-weight-500 e-font-16  line-height-100-percent'>
                                    {props.type === 1 ? "ID card details fetched success" : "Passport details fetched success"}
                                </h6>
                                :
                                <h6 className='mb-0 color-white e-primary-font py-2 e-font-weight-500 e-font-16  line-height-100-percent'>
                                    {props.type === 1 ? "Failed to fetch ID card details " : "Failed to fetch Passport details"}
                                </h6>
                        }
                        {
                            !props.rcFetched && !props.passport ?
                                <p className='mb-0 color-white e-primary-font e-font-weight-500 e-font-16  line-height-100-percent'>
                                    Please verify the auto filled details and correct as required.
                                </p>
                                :
                                <p className='mb-0 color-white e-primary-font e-font-weight-500 e-font-16  line-height-100-percent'>
                                    Your card auto-reading was not detected as this movement, but you can fill in the details manually.
                                </p>
                        }

                    </div>
                    <div className='py-4 mt-3 padding-32px-lr padding-32px-bottom px-3'>
                        <div className='row justify-content-center'>

                            <div className='col-6'>
                                <PrimaryButton label='Continue'
                                    cancel="modal"
                                    // loader={props.loader}
                                    handleClick={() => {
                                        props.closeModal()
                                    }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VerifyDetail;

VerifyDetail.defaultProps = {
    handleClose: () => { },
    type: 1,
}